import React from 'react';

class RelatorioGerencialForm extends React.Component {

    render() {
        return(
            <div>
                <p id="relatorio-ger-txt">
                    Informe o centro de custo e o ano das movimentações financeiras.<br /><br />
                    * Para baixar a planilha com a visualização agregada de todos os centros de custo,<br />
                    escolha a opção <b>Todos</b> em Centro e clique em <b>Baixar Planilha</b>.
                </p><br /><br />
                <form id="relatorio-ger-form">
                    <select value={ this.props.centro } onChange={ this.props.changeCentro }>
                        <option value="Centro">Centro</option>
                        <option value="Todos">Todos</option>
                        { this.props.centros.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.nome }</option> ) }
                    </select><br />
                    <select value={ this.props.ano } onChange={ this.props.changeAno }>
                        <option value="Ano">Ano</option>
                        { this.props.anos.map((item, i) =>
                            <option key={ i } value={ item }>{ item }</option> ) }
                    </select><br /><br />
                    <button type="button" id="relatorio-ger-voltar-btn" onClick={ this.props.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="relatorio-ger-visualizar-btn"
                        onClick={ this.props.visualizar }
                        disabled={ this.props.disabled }>
                        Visualizar Relatório
                    </button>
                    <button type="button"
                        id="relatorio-ger-baixar-btn"
                        onClick={ this.props.baixar }
                        disabled={ this.props.disabled }>
                        Baixar Planilha
                    </button><br /><br />
                </form>
            </div>
        );
    }

}

export default RelatorioGerencialForm;

